var styles = {
  "Section": "Polaris-Menu-Message__Section"
};

export { styles as default };
